var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTokenGenration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10704_241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 9.24735V10.5162L7.70987 10.5162V15.5916H8.97873V10.5162L11.5 10.5162V9.24735H5ZM8.3443 6.0752C9.17745 6.0752 10.0024 6.2393 10.7722 6.55813C11.5419 6.87696 12.2413 7.34428 12.8304 7.9334C13.4195 8.52252 13.8868 9.22191 14.2057 9.99164C14.5245 10.7614 14.6886 11.5864 14.6886 12.4195C14.6886 14.1021 14.0202 15.7158 12.8304 16.9056C11.6406 18.0954 10.0269 18.7638 8.3443 18.7638C7.51116 18.7638 6.68617 18.5997 5.91644 18.2809C5.14672 17.962 4.44733 17.4947 3.8582 16.9056C2.66842 15.7158 2 14.1021 2 12.4195C2 10.7369 2.66842 9.12319 3.8582 7.9334C5.04799 6.74361 6.66169 6.0752 8.3443 6.0752Z",
    fill: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9875 4.10081L16.62 1L15.2524 4.10081L12.1504 5.46835L15.2524 6.83588L16.62 9.93831L17.9875 6.83588L21.0895 5.46835L17.9875 4.10081Z",
    fill: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9875 17.4241L16.62 14.3232L15.2524 17.4241L12.1504 18.7916L15.2524 20.1591L16.62 23.2616L17.9875 20.1591L21.0895 18.7916L17.9875 17.4241Z",
    fill: "#B1B1B1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10704_241"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenGenration);
export default __webpack_public_path__ + "static/media/tokenGenration.3ae756b70017f083a6ec0bc9b96bf438.svg";
export { ForwardRef as ReactComponent };